module.exports = __webpack_public_path__ + "static/img/gland.9eed7ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/organs/gland.png
// module id = NJv3
// module chunks = 1